import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

const AddDocumentDialog = (props) => {
    const {open, onClose, uploadFileCallback, createEmptyDocumentCallback, loading} = props

    const [chosenFile, setChoseFile] = useState(null)

    const handleCloseDialog = () => {
        onClose()
        setChoseFile(null)
    }

    const handleUploadButtonClick = async () => {
        await uploadFileCallback(chosenFile, handleCloseDialog)
    }

    const handleCreateEmptyButtonClick = async () => {
        await createEmptyDocumentCallback(handleCloseDialog)
    }

    const onFileChange = (event) => {
        setChoseFile(event.target.files[0])
    }

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"sm"} fullWidth>
            <DialogTitle>Добавить новый документ</DialogTitle>
            <DialogContent>
                <Grid container direction={'column'} spacing={2}>
                    <Grid item>
                        <input
                            color="primary"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            type="file"
                            onChange={onFileChange}
                            id="icon-button-file-1"
                            style={{display: 'none'}}
                        />
                        <label htmlFor="icon-button-file-1">
                            <Button
                                variant="contained"
                                size="small"
                                component="span"
                                color="primary"
                                disabled={loading}
                            >
                                Выбрать файл
                            </Button>
                        </label>
                    </Grid>
                    <Grid item>
                        <Typography>
                            {chosenFile ? `Выбран файл "${chosenFile.name}"` : 'Выберите файл для загрузки'}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <LinearProgress hidden={!loading}/>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent={'space-between'}>
                    <Grid item>
                        <Button onClick={handleCreateEmptyButtonClick}>
                            Создать пустой файл
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={handleCloseDialog}>
                            Отмена
                        </Button>
                        <Button onClick={handleUploadButtonClick} disabled={!Boolean(chosenFile)}>
                            Загрузить
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};

export default AddDocumentDialog;